import {
  AfterViewInit,
  Component,
  HostListener,
  OnInit,
  ViewChild,
  EventEmitter,
  Output,
  OnDestroy,
  inject,
} from '@angular/core';
import { DateSelectionModelChange } from '@angular/material/datepicker';
import { MatAccordion, MatExpansionPanel } from '@angular/material/expansion';
// import {MatDatepickerModule} from '@angular/material/datepicker';
//import { CookieService } from 'ngx-cookie-service';
import { QuickSearchCriteria } from 'src/app/shared/entities/QuickSearchCriteria';
import { QueryMessageService } from 'src/app/core/services/broadcast/MessageDispatchingService';
import { formatDate } from '@angular/common';
import { LotService } from 'src/app/core/services/data/lot.service';
import { LotList } from 'src/app/shared/entities/LotList';
import { MatDialog } from '@angular/material/dialog';
import { LoggingService } from 'src/app/core/services/helper/log.service';
import { UpdateUserSettings } from 'src/app/shared/entities/UpdateUserSettings';
import { Subscription } from 'rxjs';
import { query } from '@angular/animations';
import { AuthService } from 'src/app/core/services/auth-security/auth.service';
import { UserService } from 'src/app/core/services/auth-security/user.service';
import { InvoiceService } from 'src/app/core/services/data/invoice.service';
import { AdjustmentService } from 'src/app/core/services/data/adjustment.services';
import { UserCredentialsFromApnLink } from 'src/app/shared/entities/UserCredentialsFromApnLink';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { RevenueTypes } from 'src/app/shared/entities/RevenueTypes';
import { LinkValidationResponse } from 'src/app/shared/entities/LinkValidationResponse';
import { QuicksearchService } from 'src/app/core/services/data/quicksearch.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { ISettingsState } from 'src/app/shared/interfaces';
import { DataService } from 'src/app/core/services/data/data.service';

var input = document.getElementById('myInput');

// Execute a function when the user presses a key on the keyboard
input?.addEventListener('keypress', function (event) {
  // If the user presses the "Enter" key on the keyboard
  if (event.key === 'Enter') {
    // Cancel the default action, if needed
    event.preventDefault();
    // Trigger the button element with a click
    document.getElementById('btnSearch')?.click();
  }
});

@Component({
  selector: 'app-quick-search-home',
  templateUrl: './quick-search-home.component.html',
  styleUrls: ['./quick-search-home.component.scss'],
})
export class QuickSearchHomeComponent implements OnInit, AfterViewInit, OnDestroy {
  urlDomain: string = '';
  quicksearchForm!: FormGroup;
  screenWidth: number = 1000;
  screenHeight: number;
  midScreenSize: number = 640;
  mobileScreenSize: number = 790;
  displayQuickSearch: boolean = true;
  displayQuickSearchSubscription: Subscription;
  quicksearchCriteriaForQuery: QuickSearchCriteria;
  queryLotNumberSelected: string = '';
  settingsStateValues: ISettingsState;

  LotListByUserName: LotList[] = [];

  //Query Fields
  lotNumber = 'No Lot Number';
  cardNumber = '';
  parkerName = '';
  companyName = '';
  invoiceNumber = '';
  revenueStartDate = '';
  revenueEndDate = '';
  transactionStartDate = '';
  transactionEndDate = '';
  invoiceType = 'ALL';
  includeZeroBalanceInvoices = 'No';
  defaultLotNumber = '';
  defaultLot: LotList;
  isInProdSimulate: boolean = true;
  customerType: string = 'ALL';

  userData: UserCredentialsFromApnLink | undefined;

  quickSearchCriteria: QuickSearchCriteria = new QuickSearchCriteria();
  lotDisplayName = 'No Lot Selected';
  displayQuickSearchRegion: boolean = true;
  theSearchCriteria = 'No Current Search Parms';
  enableMode: boolean = false; //This controls whether we display the payment grid of detailed payment/adjustment form
  disableSearchButton: boolean = false;
  cookieAutoHideSearchCriteria: boolean = true;

  //Services
  _dataService = inject(DataService);
  _appGeneralStateService = inject(AppGeneralStateService);

  constructor(
    private messageService: QueryMessageService,
    private lotService: LotService,
    public dialog: MatDialog,
    private userService: UserService,
    private authService: AuthService,
    private loggingService: LoggingService,
    private invoiceService: InvoiceService,
    private adjustmentService: AdjustmentService,
    private router: Router,
    private route: ActivatedRoute,
    private quickSearchService: QuicksearchService,
  ) {
    this.urlDomain = environment.UrlDomain;
  }

  @ViewChild(MatAccordion) accordion: MatAccordion;
  @ViewChild(MatExpansionPanel, { static: true }) matExpansionPanelElement: MatExpansionPanel;

  ngOnInit(): void {
    //const userId: string = this.dataStoreService.getValidatedUserId();
    this.setLotDisplayName();
    const userId: string = this._appGeneralStateService.userId;

    // this.getUserDataForUserId(this.dataStoreService.getValidatedUserId());
    this.quickSearchFormInit();

    this._appGeneralStateService.lotNumberSubject.subscribe({
      next: (v) => this.onLotNumberChange(v),
    });
  }

  ngOnDestroy(): void {}

  quickSearchFormInit(): void {
    this.quicksearchForm = new FormGroup({
      lotNumber: new FormControl(this._appGeneralStateService.currentLotNumber, [Validators.required]),
      invoiceNumber: new FormControl('', []),
      parkerName: new FormControl('', []),
      customerType: new FormControl('ALL', []),
      companyName: new FormControl('', []),
      invoiceType: new FormControl('ALL', []),
      includeZeroBalances: new FormControl('NO', []),
      revenueStartDate: new FormControl('', []),
      revenueEndDate: new FormControl('', []),
      transactionStartDate: new FormControl('', []),
      transactionEndDate: new FormControl('', []),
    });
  }

  onQuickSearchDoSearch(): void {
    if (this.quicksearchForm.valid) {
      //close search criteria panel if user clicked the "Hide QuickSearch Criteria on Search"
      this.displayQuickSearchRegion = !this.cookieAutoHideSearchCriteria;

      this.quickSearchCriteria = this.sendQueryMessage();
    }
  }

  setLotDisplayName(): void {
    this.lotDisplayName =
      this._appGeneralStateService.currentLotNumber + ' - ' + this._appGeneralStateService.currentLotName;
  }

  setCurrentUserLot(lotNumber: string): void {
    let defaultLot = this._appGeneralStateService.currentLotNumber;
    //this.LotListByUserName;
    let currentLotNumber = this._appGeneralStateService.currentLotNumber;
    this.lotNumber = this._appGeneralStateService.currentLotNumber;
    this.defaultLotNumber = this._appGeneralStateService.currentLotNumber;
    this.queryLotNumberSelected = this._appGeneralStateService.currentLotNumber;
  }

  ngAfterViewInit(): void {
    this.screenWidth = window.innerWidth;

    this.screenHeight = window.innerHeight;

    this.setCurrentUserLot(this.defaultLotNumber);

    this.displayQuickSearchRegion = this.quickSearchService.getQuickSearchCriteriaAutoHide();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
  }

  routeValidatedUserToLanaiHome(userData: UserCredentialsFromApnLink): void {
    //20241104 :: Marked for Deletion
    //this.authService.setAuthenticated(true);
    // this.authService.setUserId(userData.userId);
    // this.authService.setUserName(userData.userName);
    // this.authService.setDefaultLotId(userData.mostRecentLotNumber);
    // this.setLotIdNameByLotNumber(userData.mostRecentLotNumber);
    //this.completeApnLanaiLink();
  }

  setLotIdNameByLotNumber(lotNumber: string): void {
    let ii: number = 0;

    try {
      for (ii = 0; this.LotListByUserName.length; ii++) {
        if (this.LotListByUserName[ii].lotId == lotNumber) {
          this.lotDisplayName = lotNumber + ' - ' + this.LotListByUserName[ii].lotName;
        }
      }
    } catch (err) {}
  }

  getApnLaunchLink(): string {
    let linkId: string = '';

    let tempLink: any = this.route.snapshot.paramMap.get('link');
    if (tempLink !== undefined || tempLink !== null) {
      linkId = tempLink;
    }

    return linkId;
  }

  sendQueryMessage(): QuickSearchCriteria {
    let qsBuildQuery: QuickSearchCriteria = new QuickSearchCriteria();
    qsBuildQuery.lotNumber = this._appGeneralStateService.currentLotNumber;
    qsBuildQuery.customerType = this.quicksearchForm.get('customerType')!.value;
    qsBuildQuery.companyName = this.quicksearchForm.get('companyName')!.value;
    qsBuildQuery.invoiceNumber = this.quicksearchForm.get('invoiceNumber')!.value;
    qsBuildQuery.invoiceType = this.quicksearchForm.get('invoiceType')!.value;
    qsBuildQuery.parkerName = this.quicksearchForm.get('parkerName')!.value;
    qsBuildQuery.revenueStartDate = this.formatAceDateTime(this.quicksearchForm.get('revenueStartDate')!.value);
    qsBuildQuery.revenueEndDate = this.formatAceDateTime(this.quicksearchForm.get('revenueEndDate')!.value);
    qsBuildQuery.transactionStartDate = this.formatAceDateTime(this.quicksearchForm.get('transactionStartDate')!.value);
    qsBuildQuery.transactionEndDate = this.formatAceDateTime(this.quicksearchForm.get('transactionStartDate')!.value);
    qsBuildQuery.zeroBalance = this.setZeroBalanceQueryType(this.quicksearchForm.get('includeZeroBalances')!.value);
    qsBuildQuery.startDateForQuery = this.setQueryStartDate(qsBuildQuery);

    return qsBuildQuery;
  }

  setZeroBalanceQueryType(includeZeroBalanceInvoices: string): number {
    let enumQueryType: number = -1;

    switch (includeZeroBalanceInvoices.toUpperCase()) {
      case 'NO': {
        enumQueryType = 0;
        break;
      }
      case 'YES': {
        enumQueryType = 1;
        break;
      }
      case 'ONLY ZERO BALANCES': {
        enumQueryType = 2;
        break;
      }
      case 'ONLY CREDIT BALANCES': {
        enumQueryType = 3;
        break;
      }
      case 'ONLY CREDIT BALANCES': {
        enumQueryType = 3;
        break;
      }
      case 'PAST DUE BALANCES': {
        enumQueryType = 4;
        break;
      }
      default: {
        enumQueryType = 0;
        break;
      }
    }

    return enumQueryType;
  }

  onEnableAdjustments(message: any): void {
    this.enableMode = true;
  }

  setQueryStartDate(quicksearchCriteria: QuickSearchCriteria): string {
    let queryStartDate: string = '';
    let qsCriteria: QuickSearchCriteria = quicksearchCriteria; //reduce length of qsCriteria for improved legibility
    let getStartDate: boolean = true;

    //If any of the following criteria test to have a search value, then we turn off searching by a date
    if (qsCriteria.customerType !== '') getStartDate = false;

    if (qsCriteria.companyName !== '') getStartDate = false;

    if (qsCriteria.invoiceNumber !== '') getStartDate = false;

    if (qsCriteria.parkerName !== '') getStartDate = false;

    if (qsCriteria.revenueEndDate !== '') getStartDate = false;

    if (qsCriteria.revenueStartDate !== '') getStartDate = false;

    if (qsCriteria.transactionEndDate !== '') getStartDate = false;

    if (qsCriteria.transactionStartDate !== '') getStartDate = false;

    //Get current date and subtract 365 days if getStartDate === true
    if (getStartDate) {
      let dateOneYearBack: Date = new Date();
      dateOneYearBack.setDate(dateOneYearBack.getDate() - 365);

      queryStartDate = this.formatAceDateTime(dateOneYearBack.toString());
    }

    return queryStartDate;
  }

  formatAceDateTime(dateToPrepare: string): string {
    let formattedDate: string = '';

    if (dateToPrepare !== '') {
      formattedDate = formatDate(new Date(dateToPrepare), 'MM-dd-yyyy', 'en-US');
    }

    return formattedDate;
  }

  onLotNumberChange(lotNumber: any) {
    this._appGeneralStateService.lotChangeMessage();

    this.displayQuickSearchRegion = true;

    this.doSearchCriteriaReset();

    let lotNumberId = lotNumber;
    let lotName = '';

    this.LotListByUserName.forEach(function (value) {
      if (value.lotId === lotNumberId) lotName = value.lotName;
    });

    if (lotNumberId === '-1') {
      this.queryLotNumberSelected = '';
      this.disableSearchButton = true;
    } else {
      this.queryLotNumberSelected = lotNumberId;
      this.lotNumber = lotNumberId;
      let currentLotName: string = '';

      let userSettings: UpdateUserSettings = new UpdateUserSettings();

      userSettings.userId = this._appGeneralStateService.userId;
      userSettings.lotNumber = this.lotNumber;

      this.authService.setDefaultLotId(lotNumberId);

      this.authService.setLotName(lotName);

      this.lotService.setCurrentDefaultLotForUser(userSettings);
      this.defaultLotNumber = this.lotNumber;
    }

    this.setLotDisplayName();
  }

  doSearch() {
    if (this.cookieAutoHideSearchCriteria) this.displayQuickSearchRegion = false;
    else this.displayQuickSearchRegion = true;

    this.quickSearchService.setQuickSearchCriteriaAutoHide(this.displayQuickSearchRegion);

    this.sendQueryMessage();
  }

  setAutoHideSearchCriteriaOnNewSearchRequest() {}

  doSearchCriteriaReset() {
    this.quicksearchForm.patchValue({
      invoiceNumber: '',
      parkerName: '',
      customerType: 'ALL',
      companyName: '',
      invoiceType: 'ALL',
      includeZeroBalances: 'NO',
      revenueStartDate: '',
      revenueEndDate: '',
      transactionStartDate: '',
      transactionEndDate: '',
    });
  }

  setUserRoleIsAdmin(userName: string) {
    this.authService.userIdAdminRole(userName).subscribe(
      (isAdmin) => {
        this.authService.setRoleIsAdmin(isAdmin);
      },
      (err: any) => {},
      () => {},
    );
  }

  getCurrentDefaultLotForThisUser(userName: string) {
    this.lotService.getCurrentDefaultLotForUser(userName).subscribe(
      (savedLotNumber) => {
        this.defaultLotNumber = savedLotNumber;
      },
      (err: any) => {},
      () => {
        if (this.defaultLotNumber === '') {
          this.defaultLotNumber = '-1';
          this.disableSearchButton = true;
        } else {
          this.disableSearchButton = false;
          this.lotNumber = this.defaultLotNumber;
          this.queryLotNumberSelected = this.defaultLotNumber;
          this.setCurrentUserLot(this.defaultLotNumber);
        }
        // this.lotDisplayName = this.lotNumber + ' - ' + this.getSavedLotNameForThisUser(this.lotNumber);
        this.lotDisplayName = `${this._appGeneralStateService.currentLotNumber} - ${this._appGeneralStateService.currentLotName}`;

        if (this.userData !== undefined) this.routeValidatedUserToLanaiHome(this.userData);
      },
    );
  }

  getSavedLotNameForThisUser(lotNumber: string): string {
    let lotName: string = '';
    let i: number = 0;

    if (this.LotListByUserName.length <= 0) return '';

    for (i = 0; i < this.LotListByUserName.length; i++) {
      if (this.LotListByUserName[i].lotId === lotNumber) lotName = this.LotListByUserName[i].lotName;
    }

    return lotName;
  }

  isValidDate(dateString: string): boolean {
    let isValidDate: boolean = true;

    try {
      let newDate = new Date(dateString);
    } catch (error) {
      isValidDate = false;
    }
    return isValidDate;
  }

  // End of Class
}
//End of Class
